module.exports = __webpack_public_path__ + "media/logo.7e0c28be.ogg";